export default __webpack_public_path__ + "static/media/statistics.1e7b39d1.svg";